import { render } from "./FloatingMessage.vue?vue&type=template&id=5c1df0aa"
import script from "./FloatingMessage.vue?vue&type=script&lang=js"
export * from "./FloatingMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__